import type { SecretaryPermissions } from "@/domains/shared/models/ISecretaryPermissions";
import { SECRETARY_NAV_TRANSLATIONS } from "@/domains/shared/navigation/constants";
import {
    secretaryHasAgendaView,
    secretaryHasChatSettingsView,
    secretaryHasChatView,
    secretaryHasFinanceMenu,
    secretaryHasPatientTabView,
    secretaryHasRequestsView,
    secretaryHasTeamChatView,
} from "@/domains/shared/services/secretaryPermissions";
import { getTranslation } from "@mivo/i18n";
import type { LucideIcon } from "lucide-react";
import { CalendarDays, HelpCircle, LayoutDashboard, MessageCircle, Settings, User, Users, Wallet } from "lucide-react";

export type SecretaryNavItem = {
    to: string;
    label: string;
    icon: LucideIcon;
    end?: boolean;
};

export type SecretaryNavOptions = {
    secretaryAccessBlocked?: boolean;
};

export function buildSecretaryNav(
    permissions: SecretaryPermissions | null | undefined,
    options?: SecretaryNavOptions,
): SecretaryNavItem[] {
    const accessBlocked = options?.secretaryAccessBlocked === true;
    const nav: SecretaryNavItem[] = [
        { to: "/administrativo", label: getTranslation(SECRETARY_NAV_TRANSLATIONS.home), icon: LayoutDashboard, end: true },
    ];

    if (secretaryHasAgendaView(permissions)) {
        nav.push({ to: "/administrativo/agenda", label: getTranslation(SECRETARY_NAV_TRANSLATIONS.agenda), icon: CalendarDays });
    }

    if (secretaryHasPatientTabView(permissions, "generalView")) {
        nav.push({ to: "/administrativo/pacientes", label: getTranslation(SECRETARY_NAV_TRANSLATIONS.patients), icon: Users });
    }

    if (secretaryHasFinanceMenu(permissions)) {
        nav.push({ to: "/administrativo/financeiro", label: getTranslation(SECRETARY_NAV_TRANSLATIONS.finance), icon: Wallet });
    }

    if (secretaryHasRequestsView(permissions)) {
        nav.push({ to: "/administrativo/solicitacoes", label: getTranslation(SECRETARY_NAV_TRANSLATIONS.requests), icon: HelpCircle });
    }

    if (secretaryHasChatView(permissions)) {
        nav.push({ to: "/administrativo/chat", label: getTranslation(SECRETARY_NAV_TRANSLATIONS.patientChat), icon: MessageCircle });
    }

    if (!accessBlocked && secretaryHasTeamChatView(permissions)) {
        nav.push({ to: "/administrativo/chat-equipe", label: getTranslation(SECRETARY_NAV_TRANSLATIONS.professionalChat), icon: MessageCircle });
    }

    if (secretaryHasChatSettingsView(permissions)) {
        nav.push({ to: "/administrativo/configuracoes/chat", label: getTranslation(SECRETARY_NAV_TRANSLATIONS.settings), icon: Settings });
    }

    nav.push({ to: "/administrativo/perfil", label: getTranslation(SECRETARY_NAV_TRANSLATIONS.profile), icon: User });
    return nav;
}
